export const LINK_TITLE = `В избранное`;
export const ACTIVE_TEXT = `Из избранного`;
